import { useNavigate } from 'react-router-dom';

export default function AcademicCalendar() {
  const navigate = useNavigate();

  const calendarData = [
    { week: 1, date: 'January 10th & 11th', activity: '➢ First Day of the Semester' },
    { week: 2, date: 'January 17th & 18th', activity: '➢ Transitions' },
    { week: 3, date: 'January 24th & 25th', activity: 'Normal Class Schedule' },
    { week: 4, date: 'January 31st & February 1st', activity: 'Normal Class Schedule' },
    { week: 5, date: 'February 7th & 8th', activity: 'Normal Class Schedule' },
    { week: 6, date: 'February 14th & 15th', activity: '➢ In Preparation for Ramadan (Workshop)' },
    { week: 7, date: 'February 21st & 22nd', activity: 'Normal Class Schedule' },
    { week: 8, date: 'February 28th & March 1st', activity: 'Normal Class Schedule' },
    { week: 9, date: 'March 7th & 8th', activity: 'Normal Class Schedule' },
    { week: 10, date: 'March 14th & 15th', activity: '➢ Last 10 Nights (NO CLASS)' },
    { week: 11, date: 'March 21st & 22nd', activity: '➢ Eid Break (NO CLASS)' },
    { week: 12, date: 'March 28th & 29th', activity: 'Normal Class Schedule' },
    { week: 13, date: 'April 4th & 5th', activity: '➢ Mid-Term Exams' },
    { week: 14, date: 'April 11th & 12th', activity: '➢ Parent/Student/Teacher Conference' },
    { week: 15, date: 'April 18th & 19th', activity: 'Normal Class Schedule' },
    { week: 16, date: 'April 25th & 26th', activity: 'Normal Class Schedule' },
    { week: 17, date: 'May 2nd & 3rd', activity: 'Normal Class Schedule' },
    { week: 18, date: 'May 9th & 10th', activity: 'Normal Class Schedule' },
    { week: 19, date: 'May 16th & 17th', activity: 'Normal Class Schedule' },
    { week: 20, date: 'May 23rd & 24th', activity: 'Normal Class Schedule' },
    { week: 21, date: 'May 30th & 31st', activity: '➢ Final Exams' }
  ];

  return (
    <div className="elegant-font min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-neutral-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/')}
                className="p-2 text-neutral-600 hover:text-neutral-900"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
              </button>
              <img 
                src="/logo.jpeg" 
                alt="Abubakar Islamic Institute Logo" 
                className="h-10 w-auto object-contain"
              />
              <h1 className="text-lg font-bold text-neutral-900">Academic Calendar</h1>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Class Schedule */}
        <div className="bg-white rounded-lg shadow-sm border border-neutral-200">
          <div className="p-4 sm:p-6">
            <div className="text-center mb-6">
              <h2 className="text-2xl sm:text-3xl font-bold text-neutral-900 mb-2">
                Class Schedule
              </h2>
            </div>

            {/* Mobile-friendly Schedule Cards */}
            <div className="space-y-4 sm:hidden">
              {[
                { teacher: 'Sheikh Ali', room: '12', schedule: 'Qur\'an: 9:30 – 10:50\nIslamic Studies: 11:05 – 12:30', break: '10:50 – 11:05' },
                { teacher: 'Macalima Ruwayda', room: '7', schedule: 'Qur\'an: 9:30 – 10:30\nIslamic Studies: 10:45 – 12:30', break: '10:30 - 10:45' },
                { teacher: 'Macalin Uthmaan', room: '11', schedule: 'Qur\'an: 9:30 – 10:50\nIslamic Studies: 11:05 – 12:30', break: '10:50 – 11:05' },
                { teacher: 'Macalima Safiya & Macalima Rayaan', room: '10', schedule: 'Qur\'an: 9:30 – 10:30\nIslamic Studies: 10:45 – 12:30', break: '10:30-10:45' },
                { teacher: 'Macalin Jasim', room: '13', schedule: 'Qur\'an: 9:30 – 10:30\nIslamic Studies: 10:30 – 12:30', break: '11:00 - 11:15' },
                { teacher: 'Macalin Mubarak', room: '6', schedule: 'Qur\'an: 9:30 – 10:30\nIslamic Studies: 10:30– 12:30', break: '11:00 - 11:15' },
                { teacher: 'Imam Mowlid & Macalin Abdiwasi - Levels 4 & 5 (Girls)', room: '14', schedule: 'Islamic Studies: 9:30 – 11:10\nArabic: 11:25 – 12:30', break: '11:10 – 11:25' },
                { teacher: 'Imam Mowlid & Macalin Abdiwasi - Levels 4 & 5 (Boys)', room: '9', schedule: 'Arabic: 9:30 – 11:10\nIslamic Studies: 11:25 – 12:30', break: '11:10 – 11:25' }
              ].map((item, index) => (
                <div key={index} className="bg-neutral-50 rounded-lg p-4 border border-neutral-200">
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <h3 className="font-semibold text-neutral-900 text-sm mb-1">{item.teacher}</h3>
                      <p className="text-xs text-neutral-600">Room #{item.room}</p>
                    </div>
                  </div>
                  <div className="mt-3 space-y-1">
                    <p className="text-xs text-neutral-700 whitespace-pre-line">{item.schedule}</p>
                    <p className="text-xs text-neutral-600 mt-2">
                      <span className="font-medium">Break:</span> {item.break}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden sm:block overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-neutral-200 bg-neutral-50">
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Teacher</th>
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Room #</th>
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Schedule</th>
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Break Time</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-neutral-100">
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Sheikh Ali</td>
                    <td className="py-3 px-4 text-neutral-600">12</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:50</div>
                      <div>Islamic Studies: 11:05 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">10:50 – 11:05</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Macalima Ruwayda</td>
                    <td className="py-3 px-4 text-neutral-600">7</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:30</div>
                      <div>Islamic Studies: 10:45 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">10:30 - 10:45</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Macalin Uthmaan</td>
                    <td className="py-3 px-4 text-neutral-600">11</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:50</div>
                      <div>Islamic Studies: 11:05 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">10:50 – 11:05</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Macalima Safiya & Macalima Rayaan</td>
                    <td className="py-3 px-4 text-neutral-600">10</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:30</div>
                      <div>Islamic Studies: 10:45 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">10:30-10:45</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Macalin Jasim</td>
                    <td className="py-3 px-4 text-neutral-600">13</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:30</div>
                      <div>Islamic Studies: 10:30 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">11:00 - 11:15</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Macalin Mubarak</td>
                    <td className="py-3 px-4 text-neutral-600">6</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Qur'an: 9:30 – 10:30</div>
                      <div>Islamic Studies: 10:30– 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">11:00 - 11:15</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Imam Mowlid & Macalin Abdiwasi - Levels 4 & 5 (Girls)</td>
                    <td className="py-3 px-4 text-neutral-600">14</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Islamic Studies: 9:30 – 11:10</div>
                      <div>Arabic: 11:25 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">11:10 – 11:25</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium text-neutral-900">Imam Mowlid & Macalin Abdiwasi - Levels 4 & 5 (Boys)</td>
                    <td className="py-3 px-4 text-neutral-600">9</td>
                    <td className="py-3 px-4 text-neutral-700">
                      <div>Arabic: 9:30 – 11:10</div>
                      <div>Islamic Studies: 11:25 – 12:30</div>
                    </td>
                    <td className="py-3 px-4 text-neutral-600">11:10 – 11:25</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Academic Calendar */}
        <div className="bg-white rounded-lg shadow-sm border border-neutral-200">
          <div className="p-4 sm:p-6">
            <div className="text-center mb-6">
              <h2 className="text-2xl sm:text-3xl font-bold text-neutral-900 mb-2">
                Spring 2026 Academic Calendar
              </h2>
              <p className="text-sm text-neutral-500">
                *This schedule may be subject to change, and any changes will be communicated inshaAllah
              </p>
            </div>

            {/* Mobile-friendly Calendar */}
            <div className="space-y-3 sm:hidden">
              {calendarData.map((item) => (
                <div key={item.week} className="bg-neutral-50 rounded-lg p-4 border border-neutral-200">
                  <div className="flex items-start justify-between mb-2">
                    <span className="font-semibold text-neutral-900">Week {item.week}</span>
                    <span className="text-sm text-neutral-600">{item.date}</span>
                  </div>
                  <p className="text-sm text-neutral-700">{item.activity}</p>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden sm:block overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-neutral-200 bg-neutral-50">
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Week</th>
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Date</th>
                    <th className="text-left py-3 px-4 font-semibold text-neutral-700">Activity/Program</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-neutral-100">
                  {calendarData.map((item) => (
                    <tr key={item.week} className="hover:bg-neutral-50 transition-colors">
                      <td className="py-3 px-4 font-medium text-neutral-900">{item.week}</td>
                      <td className="py-3 px-4 text-neutral-600">{item.date}</td>
                      <td className="py-3 px-4 text-neutral-700">{item.activity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
